import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';

import { SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { LabelCode } from '@app/shared/interfaces/label-code.interface';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';
import { MaritalStatus } from '@app/shared/enums/marital-status';
import { WorkingStatus } from '@app/shared/enums/working-status';

@Component({
    selector: 'app-additional-data-first',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './additional-data-first.component.html',
    styleUrl: './additional-data-first.component.scss',
})
export class AdditionalDataFirstComponent {
    @ViewChild('maritalStatusCasado') maritalStatusCasado!: ElementRef;

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    additionalDataTitle = 'features.additionalData.additionalDataTitle';
    additionalDataSubtitle = 'features.additionalData.additionalDataSubtitle';
    selectMaritalStatus = 'features.additionalData.additionalDataFirst.selectMaritalStatus';
    marriedButton = 'features.additionalData.additionalDataFirst.married';
    singleButton = 'features.additionalData.additionalDataFirst.singleButton';
    childrenNumber = 'features.additionalData.additionalDataFirst.childrenNumber';
    moreChildren = 'features.additionalData.additionalDataFirst.moreChildren';
    moreOptions = 'features.additionalData.additionalDataFirst.moreOptions';
    lessOptions = 'features.additionalData.additionalDataFirst.lessOptions';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    selectedMaritalStatus!: LabelCode;
    showMoreMaritalStatus = false;

    childrenNumberList: string[] = ['0', '1', '2', '3', 'Mas'];
    selectedNumberList: string = "";

    showMoreChildrenNumber = false;

    private appData = inject(AppService);
    formGroup: any;

    maritalStatusOptions: any;

    maritalStatusOptionsExtra = [
        { label: 'Casado', code: MaritalStatus.MARRIED},
        { label: 'Soltero', code: MaritalStatus.SINGLE},
        { label: 'Divorciado', code: MaritalStatus.DIVORCED},
        { label: 'Viudo', code: MaritalStatus.WIDOW},
        { label: 'Pareja de hecho', code: MaritalStatus.UNMARRIED_PARTNERS},
        { label: 'Otros', code: MaritalStatus.OTHER}
    ];

    focusedIndex: number | null = null;

    // Opciones filtradas
    filteredMaritalStatusOptions = this.maritalStatusOptionsExtra.filter(option => (option.code == MaritalStatus.MARRIED || option.code == MaritalStatus.SINGLE));

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder
    ) {
        this.changeStepService.changeStep(10);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        //this.selectedMaritalStatus =  { label: 'Casado', code: MaritalStatus.C };

        this.createForm();
        this.setValuesForm(this.appData.data.userData.additionalDataFirst);

        this.maritalStatusOptions = this.filteredMaritalStatusOptions;

        this.formIsValid();
    }

    createForm() {
        this.formGroup = this.fb.group({
            maritalStatus: new FormControl(this.selectedMaritalStatus ? this.selectedMaritalStatus.code : '', [Validators.required]),
            childrenNumber: new FormControl('', [Validators.required])
        });
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.formGroup = this.fb.group({
                maritalStatus: new FormControl(value.maritalStatus ? value.maritalStatus : '', [Validators.required]),
                childrenNumber: new FormControl(value.childrenNumber ? value.childrenNumber : '', [Validators.required])
            });
        }
    }

    //-------------------------//
    //--------ON CLICK---------//
    //-------------------------//
/*
    onClickMaritalStatus(event: SelectButtonOptionClickEvent) {
        if (event != undefined) this.selectedMaritalStatus = event.option;

        this.createForm();

        this.formGroup.controls['childrenNumber'].setValue('');

        this.formIsValid();
    }
 */
    onClickMaritalStatusButton(maritalStatus: any) {
        this.selectedMaritalStatus = maritalStatus.option;
        this.formGroup.controls['maritalStatus'].patchValue(this.selectedMaritalStatus.code? this.selectedMaritalStatus.code: '');
        // this.toggleActiveClass(maritalStatus);
        this.formIsValid();

    }

    onClickChildrenNumberButton(childrenNumber: any) {
        this.selectedNumberList = childrenNumber.option;
        this.formGroup.controls['childrenNumber'].patchValue(this.selectedNumberList);

        this.formIsValid();
    }

    onChangeChildrenNumberInput(event: any) {

    	const value = event.target.value;
    	this.formGroup.controls['childrenNumber'].patchValue(value);
    }

    onClickMaritalStatus (event:boolean) {
        if(event){
            this.maritalStatusOptions = this.maritalStatusOptionsExtra;
        } else {
            this.maritalStatusOptions = this.filteredMaritalStatusOptions;
        }

        this.showMoreMaritalStatus = event;
    }


    onClickChildrenNumberMore () {
        this.showMoreChildrenNumber = true;
        //this.createForm();
        this.formIsValid();
    }

    onClickChildrenNumberLess () {
        this.showMoreChildrenNumber = false;
        this.formGroup.controls['childrenNumber'].patchValue(this.selectedNumberList);
        //this.createForm();
        //this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'additional-data-first');
        if(this.appData.data.userData.workingSituation.workStatus == WorkingStatus.WORKING) {
            this.router.navigate(['/main/step/contract-type'], { relativeTo: this.route });
        } else {
            this.router.navigate(['/main/step/working-situation'], { relativeTo: this.route });
        }
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'additional-data-first');
        this.router.navigate(['/main/step/additional-data-second'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}